module.exports = __webpack_public_path__ + "img/00-language-icon.4e7517da.svg";